import { EmpiricaClassic } from "@empirica/core/player/classic";
import { EmpiricaContext } from "@empirica/core/player/classic/react";
import { EmpiricaMenu, EmpiricaParticipant } from "@empirica/core/player/react";
import React from "react";
import { Game } from "./Game.jsx";
import { ExitSurvey } from "./intro-exit/ExitSurvey.jsx";
import { Introduction } from "./intro-exit/Introduction.jsx";
import { Agreement } from "./intro-exit/Agreement.jsx";
import { InitialPrediction } from "./intro-exit/InitialPrediction.jsx";
import { CustomParticipantCreate } from "./components/CustomParticipantCreate.jsx";
import MyLobby from "./components/MyLobby.jsx";

export default function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const playerKey = urlParams.get("participantKey") || "";

  const { protocol, host } = window.location;
  const url = `${protocol}//${host}/query`;

  console.log("App component loaded", { playerKey, url });

  function introSteps({ game, player }) {
    console.log("Intro steps called", { game: !!game, player: !!player });

    // Check if player has timed out in lobby or completed result stage individually
    const lobbyTimeout = player?.get("lobbyTimeout");
    const readyToExit = player?.get("readyToExit");

    console.log("Player state check", { lobbyTimeout, readyToExit });

    if (lobbyTimeout || readyToExit) {
      // Skip intro steps and go directly to exit survey
      console.log("Player ready to exit, skipping intro steps");
      return [];
    }

    // Get treatment information
    const treatment = game?.get("treatment") || {};
    const treatmentType = treatment.treatmentType;

    // Check if player has already completed pre-lobby prediction
    const preLobbyCompleted = player?.get("preLobbyCompleted");

    if (preLobbyCompleted) {
      // Player has completed initial prediction, skip to lobby
      console.log("Player has completed pre-lobby prediction, moving to lobby");
      return [];
    }

    // Include initial prediction step for all treatments
    return [Agreement, Introduction, InitialPrediction];
  }

  function exitSteps({ game, player }) {
    console.log("Exit steps called", { game: !!game, player: !!player });
    // Always include exit survey, but it will handle lobby timeout differently
    return [ExitSurvey];
  }

  // Check if we have a playerKey
  if (!playerKey) {
    return (
      <div className="min-h-screen bg-yellow-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
          <h1 className="text-xl font-bold text-gray-900 mb-4">
            Missing Participant Key
          </h1>
          <p className="text-gray-600 mb-4">
            You need a participant key to join the experiment. Please check your invitation link.
          </p>
          <p className="text-sm text-gray-500">
            URL should contain: ?participantKey=xxxxx
          </p>
        </div>
      </div>
    );
  }

  console.log("Rendering EmpiricaParticipant", { url, playerKey });

  return (
    <EmpiricaParticipant url={url} ns={playerKey} modeFunc={EmpiricaClassic}>
      <div className="h-screen relative">
        <EmpiricaMenu position="bottom-left" />
        <div className="h-full overflow-auto">
          {/* disableConsent removes Empirica's built-in consent screen, which
              otherwise renders before player creation with generic text that
              contradicts the IRB form. Agreement.jsx is the only consent step. */}
          <EmpiricaContext
            disableConsent
            introSteps={introSteps}
            exitSteps={exitSteps}
            playerCreate={CustomParticipantCreate}
            lobby={MyLobby}
          >
            <Game />
          </EmpiricaContext>
        </div>
      </div>
    </EmpiricaParticipant>
  );
}
